package com.ai.mitra.theme

import androidx.compose.ui.graphics.Color


val lightBackgroundColor = Color(0xff171717)
val borderColor = Color(0xff262626)
val selectedBGColor = Color(0xff3a3535)
val lightBorderColor = Color(0xff3a3535)
val whiteColor = Color(0xffffffff)
val blackColor = Color(0xff000000)
val selectionColor = Color(0xff083fab)
val textHintColor = Color(0xff7e8d98)
val redColor = Color(0xFF93000A)